import { useParams } from 'wouter';

import Subpage from '@/ui/components/subpage';
import type { ActivityItem } from '@/ui/flux/tx-log/types';
import useActivityItem from '@/ui/hooks/use-activity-item';
import Data from './components/data.js';
import Footer from './components/footer.js';
import Hero from './components/hero.js';

const DEFAULT_TITLE = 'Transaction';
const TITLE_BY_ACTIVITY_TYPE: Partial<Record<ActivityItem['type'], string>> = {
  exchange: 'Swap',
  fiat: 'Purchase',
};

function TransactionDetailPage() {
  const { id } = useParams<{ id: string }>();

  // TODO: Render 404 page.
  if (!id) {
    throw new Error('Invalid id');
  }

  const activityItem = useActivityItem(id);

  return (
    <Subpage
      title={
        (activityItem && TITLE_BY_ACTIVITY_TYPE[activityItem.type]) ??
        DEFAULT_TITLE
      }
    >
      <Hero activityItem={activityItem} />
      <Data activityItem={activityItem} />
      <Footer activityItem={activityItem} />
    </Subpage>
  );
}

export default TransactionDetailPage;
